import React from 'react';
import {List, useTranslate} from 'react-admin';
import {Box, Typography} from '@mui/material';
import {t} from '../themes/statamicTokens';
import StatamicListPage from '../components/statamic/StatamicListPage';
import {formatDate, formatDateTime} from '../lib/dates';

const TextCell = ({value}) => (
    <Typography
        sx={{
            fontSize: `${t.type.body.size}px`,
            color: value ? t.color.text.secondary : t.color.text.muted,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        }}
    >
        {value ?? '—'}
    </Typography>
);

const NumCell = ({value}) => (
    <Typography
        sx={{
            fontSize: `${t.type.body.size}px`,
            color: value == null ? t.color.text.muted : t.color.text.primary,
            fontVariantNumeric: 'tabular-nums',
            textAlign: 'right',
        }}
    >
        {value ?? '—'}
    </Typography>
);

const ChildUpdatePostStatsListStatamicInner = () => {
    const translate = useTranslate();

    const columns = [
        {
            key: 'child', label: translate('Child name'), sortable: true, sortField: 'child_name',
            render: (r) => (
                <Typography sx={{fontSize: `${t.type.bodyStrong.size}px`, fontWeight: t.type.bodyStrong.weight, color: t.color.text.primary, whiteSpace: 'nowrap'}}>
                    {r.child_name || '—'}
                </Typography>
            ),
        },
        {
            key: 'guardian', label: translate('Guardian name'), width: 200,
            render: (r) => <TextCell value={r.guardian_name}/>,
        },
        {
            key: 'last_charity_post', label: translate('Last charity post'), sortable: true, sortField: 'last_charity_post_date', width: 140,
            render: (r) => <TextCell value={formatDate(r.last_charity_post_date)}/>,
        },
        {
            key: 'nr_charity_posts', label: translate('# of charity posts'), width: 130,
            render: (r) => <NumCell value={r.nr_of_charity_posts}/>,
        },
        {
            key: 'last_guardian_post', label: translate('Last guardian post'), sortable: true, sortField: 'last_guardian_post_date', width: 140,
            render: (r) => <TextCell value={formatDate(r.last_guardian_post_date)}/>,
        },
        {
            key: 'nr_guardian_posts', label: translate('# of guardian posts'), width: 140,
            render: (r) => <NumCell value={r.nr_of_guardian_posts}/>,
        },
        {
            key: 'nr_guardian_likes', label: translate('# likes'), width: 90,
            render: (r) => <NumCell value={r.nr_of_guardian_likes}/>,
        },
        {
            key: 'nr_guardian_comments', label: translate('# comments'), width: 110,
            render: (r) => <NumCell value={r.nr_of_guardian_comments}/>,
        },
        {
            key: 'last_access', label: translate('Last access date'), width: 170,
            render: (r) => <TextCell value={formatDateTime(r.last_access_date_time)}/>,
        },
    ];

    return (
        <StatamicListPage
            scoped
            title={translate('Child Update Post Statistics')}
            subtitle="Engagement counters per child-sponsor pairing"
            columns={columns}
        />
    );
};

const ChildUpdatePostStatsListStatamic = (props) => (
    <List
        {...props}
        perPage={25}
        actions={false}
        pagination={false}
        component={Box}
        sx={{
            backgroundColor: t.color.page,
            '& .RaList-main': {backgroundColor: t.color.page},
        }}
    >
        <ChildUpdatePostStatsListStatamicInner/>
    </List>
);

export default ChildUpdatePostStatsListStatamic;
